var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "flex w-full rounded overflow-hidden border border-primary-color",
    },
    _vm._l(_vm.options, function (option) {
      return _c(
        "div",
        { key: option.value, staticClass: "radio-container flex-1" },
        [
          _c("input", {
            staticClass: "customRadio",
            attrs: { type: "radio", id: option.value, name: _vm.name },
            domProps: {
              value: option.value,
              checked: _vm.value == option.value,
            },
            on: { change: _vm.handleChange },
          }),
          _c(
            "label",
            { class: { blue: _vm.blue }, attrs: { for: option.value } },
            [_vm._v(" " + _vm._s(option.label) + " ")]
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }